module.exports = __webpack_public_path__ + "img/b6a069f.jpg";